import { render, staticRenderFns } from "./PasteAnnotationWithLinkModal.vue?vue&type=template&id=767060b0&scoped=true"
import script from "./PasteAnnotationWithLinkModal.vue?vue&type=script&lang=js"
export * from "./PasteAnnotationWithLinkModal.vue?vue&type=script&lang=js"
import style0 from "./PasteAnnotationWithLinkModal.vue?vue&type=style&index=0&id=767060b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767060b0",
  null
  
)

export default component.exports